import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import {
  Theme,
  Card,
  Flex,
  Text,
  TextField,
  Button,
  Link,
} from "@radix-ui/themes";
import { toast } from "react-hot-toast";
import { API_URL } from "../constants/constants";

function Login() {
  const [form, setForm] = useState({ email: "", password: "" });
  const navigate = useNavigate();

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    try {
      const res = await axios.post(`${API_URL}/api/auth/login`, form);
      localStorage.setItem("token", res.data.token);
      navigate("/dashboard");
    } catch (err) {
      toast.error("Error logging in.", {
        style: {
          border: "1px solid rgb(0, 0, 0)",
          padding: "12px",
          color: "#000",
        },
        iconTheme: {
          primary: "#000",
          secondary: "#FFFAEE",
        },
      });
    }
  };

  return (
    <Theme appearance="dark" accentColor="crimson" radius="medium">
      <Flex
        align="center"
        justify="center"
        style={{ minHeight: "100vh", padding: "1rem" }}
      >
        <Card size="3" style={{ width: "100%", maxWidth: "400px" }}>
          <Flex direction="column" gap="4">
            <Text size="5" weight="bold" align="center">
              Welcome Back
            </Text>

            <TextField.Root
              type="email"
              name="email"
              placeholder="Email"
              value={form.email}
              onChange={handleChange}
              required
            />

            <TextField.Root
              type="password"
              name="password"
              placeholder="Password"
              value={form.password}
              onChange={handleChange}
              required
            />

            <Button onClick={handleSubmit}>Login</Button>

            <Text size="2" align="center" style={{ marginTop: "1rem" }}>
              Don't have an account?{" "}
              <Link asChild color="crimson">
                <RouterLink to="/signup">Sign up.</RouterLink>
              </Link>
            </Text>
          </Flex>
        </Card>
      </Flex>
    </Theme>
  );
}

export default Login;
